import { render, staticRenderFns } from "./BaseIndivs.vue?vue&type=template&id=14587b42&scoped=true&"
import script from "./BaseIndivs.vue?vue&type=script&lang=js&"
export * from "./BaseIndivs.vue?vue&type=script&lang=js&"
import style0 from "./BaseIndivs.vue?vue&type=style&index=0&id=14587b42&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "14587b42",
  null
  
)

export default component.exports